export default "__VITE_ASSET__P_OxQnTY__"